export default __webpack_public_path__ + "static/media/sign-image.69e3bcd0.jpg";